module.exports = __webpack_public_path__ + "static/media/32.24cb1924.jpg";